import { DotMatrix, StatCard } from '@clickguard/design-system'
import { useStores } from 'hooks'
import { useEffect } from 'react'
import { useUiStore } from 'store'
import { LoginMethodRows } from './login-method-card'

export const LoginMethod = () => {
	const { userStore } = useStores()
	const { getLoginMethods, loginMethods } = userStore
	const isLoading = useUiStore((s) => s.isLoading)

	useEffect(() => {
		const getData = async () => {
			await getLoginMethods()
		}
		getData()
	}, [])

	return (
		<StatCard
			size="regular"
			divider={false}
			className="w-full !p-4 !gap-4"
			title={
				<span className="text-[18px] leading-6 font-medium text-t-base-blue">
					Login methods
				</span>
			}
		>
			{isLoading('USER_GET_LOGIN_METHODS') ? (
				<div className="flex justify-center py-8">
					<DotMatrix size="lg" />
				</div>
			) : (
				loginMethods?.map((item) => (
					<LoginMethodRows
						key={item.id}
						item={item}
						showDelete={loginMethods.length > 1}
						loading={isLoading('USER_CHANGE_MAIN_EMAIL')}
					/>
				))
			)}
		</StatCard>
	)
}
